import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import { formatCurrencyWithDecimal } from "common/utils/currency"

const withEuro = (n: $TSMigrationFixMe) => `${n} ${DEFAULT_COUNTRY_SELECTED}`
const toTwoDecimals = (n: $TSMigrationFixMe) =>
  Number(n).toFixed(2).replace(".", ",")
export const formatEuro = (n: $TSMigrationFixMe) => withEuro(toTwoDecimals(n))
export const formatImpuesto = (
  nombre: $TSMigrationFixMe,
  porcentaje: $TSMigrationFixMe
) => `${nombre} (${porcentaje}%)`

export const formats = {
  precio: formatCurrencyWithDecimal,
  total: formatCurrencyWithDecimal,
  impuesto: formatCurrencyWithDecimal,
}

export const handleUpdateTotalValue = (
  concepto: $TSMigrationFixMe,
  total: $TSMigrationFixMe
) => concepto.precioVenta * total

export const getConceptoCondition = (
  concepto: $TSMigrationFixMe,
  valorActual: $TSMigrationFixMe
) =>
  concepto.precioVenta === valorActual.precioVenta &&
  concepto.concepto === valorActual.concepto

export const getImpuestoCondition = (
  concepto: $TSMigrationFixMe,
  valorActual: $TSMigrationFixMe
) => {
  return (
    concepto.impuestoArticuloTipoId === valorActual.impuestoArticuloTipoId &&
    concepto.impuestoArticuloPorcentaje ===
      valorActual.impuestoArticuloPorcentaje
  )
}

export const handleUpdateConceptShape = (
  acumulador: $TSMigrationFixMe,
  valorActual: $TSMigrationFixMe
) => {
  return acumulador.map((concepto: $TSMigrationFixMe) => {
    if (getConceptoCondition(concepto, valorActual)) {
      const total = concepto.cantidad + valorActual.cantidad
      return {
        ...concepto,
        cantidad: total,
        subtotal: handleUpdateTotalValue(concepto, total),
        impuesto: concepto.impuesto + valorActual.impuesto,
      }
    }
    return concepto
  })
}
export const handleUpdateImpuestoShape = (
  acumulador: $TSMigrationFixMe,
  valorActual: $TSMigrationFixMe
) => {
  return acumulador.map((concepto: $TSMigrationFixMe) => {
    if (
      concepto.impuestoArticuloTipoId === valorActual.impuestoArticuloTipoId &&
      concepto.impuestoArticuloPorcentaje ===
        valorActual.impuestoArticuloPorcentaje
    ) {
      const total = concepto.totalImpuesto + valorActual.impuesto
      return {
        ...concepto,
        totalImpuesto: total,
      }
    }
    return concepto
  })
}

export const handleJoinDuplicates = (
  conceptos: $TSMigrationFixMe,
  condition: $TSMigrationFixMe,
  shape: $TSMigrationFixMe
) => {
  const result = conceptos?.reduce(
    (acumulador: $TSMigrationFixMe, valorActual: $TSMigrationFixMe) => {
      const isDuplicated = acumulador.find((concepto: $TSMigrationFixMe) =>
        condition(concepto, valorActual)
      )
      if (isDuplicated) {
        return shape(acumulador, valorActual)
      }

      return [
        ...acumulador,
        { ...valorActual, totalImpuesto: valorActual.impuesto },
      ]
    },
    []
  )
  return result
}
